export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const APP_NAME = "Henkel E2E Process Manager";
